import { breakpoints } from "../utils"
const megamenuTriggers = Array.from(document.querySelectorAll(".js-megamenu"))
const megamenu = document.querySelector(".megamenu")

megamenuTriggers.forEach((trigger) => {
	trigger.addEventListener("click", (e) => {
		if (window.matchMedia(breakpoints.desk).matches) {
			e.preventDefault()
			megamenu.classList.toggle("is-active")
			document.body.classList.toggle("megamenu-active")
		}
	})
})